import type { SettlementFormValues } from '@inflearn/modals';

export const EVENT_ID = {
  INSTRUCTOR_COUPON_MODAL: 'instructor-coupon-modal',
  MY_CATEGORY_MODAL: 'my-category-modal',
  WELCOME_MODAL: 'welcome-modal',
  INTEGRATED_CERTIFICATION_MODAL: 'integrated-certification-modal',
  MARKETING_AGREEMENT_MODAL: 'marketing-agreement-modal',
  SETTLEMENT_MODAL: 'settlement-modal',
  APP_SHELL: 'app-shell',
} as const;

export type EventId = (typeof EVENT_ID)[keyof typeof EVENT_ID];

export interface EventPropsMap extends Record<EventId, Record<string, unknown>> {
  [EVENT_ID.INTEGRATED_CERTIFICATION_MODAL]: {
    courseId: number;
    courseTitle: string;
    unitId: number;
  };
  [EVENT_ID.INSTRUCTOR_COUPON_MODAL]: {
    now: number;
  };
  [EVENT_ID.SETTLEMENT_MODAL]: {
    onComplete: (formValues: SettlementFormValues) => void;
  };
  [EVENT_ID.APP_SHELL]: {
    children: string;
  };
}
